import { render, staticRenderFns } from "./gzcl.vue?vue&type=template&id=6fd0333e&scoped=true"
import script from "./gzcl.vue?vue&type=script&lang=js"
export * from "./gzcl.vue?vue&type=script&lang=js"
import style0 from "./gzcl.vue?vue&type=style&index=0&id=6fd0333e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0333e",
  null
  
)

export default component.exports